import type { Ref, TextareaHTMLAttributes } from "react";

import { textarea } from "~/components/Textarea.css";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: Ref<HTMLTextAreaElement>;
}

/** Thin wrapper around a native <textarea> in the Input box. Forwards every
 *  native prop. */
export function Textarea({ className, ref, ...rest }: TextareaProps) {
  const merged =
    className !== undefined && className.length > 0 ? `${textarea} ${className}` : textarea;
  return <textarea ref={ref} className={merged} {...rest} />;
}
